import React, {FC, ReactNode} from "react";
import './GridAreaContentLayoutButton.css'
import classnames from "classnames";

export const GridAreaContentLayoutButton: FC<{
  onClick: (e: any) => void,
  label: string,
  icon?: ReactNode,
  disabled?: boolean,
}> = ({
  onClick,
  label,
  icon,
  disabled,
}) => {

  return (
    <button
      onClick={onClick}
      className={classnames("grid-area-content-layout-button", { "disabled": disabled })}
      disabled={disabled}
    >
      {label}
      {icon && React.cloneElement(icon as React.ReactElement, {
        className: "icon-aligned-middle",
        size: 18
      })}
    </button>
  )
}